"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var navItem_1 = require("./navItem");
exports.Admin = function (_a) {
    var name = _a.name, profileImg = _a.profileImg;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(navItem_1.NavItem, { item: {
                logo: profileImg,
                label: name,
                children: [
                    {
                        label: "Settings",
                        url: "/users/edit"
                    },
                    {
                        label: "Logout",
                        url: "/users/sign_out"
                    }
                ]
            }, id: "user-menu" })));
};
